import React, { useState, useEffect } from 'react';
import EchartsBar from 'echarts-for-react';
import { StatisticDataVO } from '@/types/camp/admin/statisticDataType';
import NoData from '@/components/noData';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface Props {
  data?: StatisticDataVO;
}
const EchartsBarDynamic: React.FC<Props> = ({ data }) => {
  const [options, setOptions] = useState<{}>();
  const [valueList, setValueList] = useState<string[]>([]);
  const [totalList, setTotalList] = useState<number[]>([]);
  const [dataHeight, setDataHeight] = useState<number>(0);

  useEffect(() => {
    if (data?.studentDynamicRanking) {
      let newArr = data?.studentDynamicRanking.map((student) => {
        return student.realName ? student.realName : student.username;
      });
      let totals = data?.studentDynamicRanking.map((student) => student.total);
      setValueList(newArr);
      setTotalList(totals);
    }
  }, [data?.studentDynamicRanking]);

  useEffect(() => {
    if (valueList.length > 0 && totalList.length > 0) {
      const option = {
        grid: {
          left: '1',
          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params: any) {
            if (params && params.length > 0) {
              const index = params[0].dataIndex;
              const value = valueList[index] || '未知';
              return `${value}<br/>互动频次: ${totalList[index] || '0'}次`;
            }
            return '';
          },
        },
        yAxis: {
          type: 'category',
          data: valueList,
          axisLabel: {
            formatter: function (value: string) {
              if (value.length > 6) {
                return value.slice(0, 6) + '...';
              }
              return value;
            },
          },
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            label: {
              show: true,
              position: 'right',
              formatter: function (params: any) {
                return params.value;
              },
            },
            data: totalList,
            type: 'bar',
            // barWidth: '14',
            barCategoryGap: '14',
            itemStyle: {
              color: '#4096FF',
            },
          },
        ],
      };

      setTimeout(function () {
        console.log(option);
        setOptions(option);
        data && setDataHeight(data?.studentDynamicRanking.length * 36);
      }, 500);
    }
  }, [data?.studentDynamicRanking, valueList, totalList]);

  return (
    <div
      className="com_cmap_card_box"
      style={{ marginBottom: 24, height: '100%', overflow: 'hidden' }}
    >
      <div className="com_card_title16 flex_1" style={{ marginBottom: 16 }}>
        <span>学员参与互动排行</span>
        <Tooltip placement="top" title="学员在打卡营中发帖的频次排行（包含分享心得以及回复）">
          <QuestionCircleOutlined className="col808 f14" style={{ marginLeft: 4, marginTop: 2 }} />
        </Tooltip>
      </div>
      {data?.studentDynamicRanking && data?.studentDynamicRanking.length > 0 ? (
        <div style={{ height: 370, overflowY: 'scroll' }}>
          {options && dataHeight && (
            <EchartsBar
              option={options}
              style={{
                minHeight: 370,
                height: dataHeight + 50,
                marginTop: '-50px',
              }}
            />
          )}
        </div>
      ) : (
        <NoData name="暂无数据" />
      )}
    </div>
  );
};
export default EchartsBarDynamic;
